import { render } from "./RulesContent.vue?vue&type=template&id=e1541f26&scoped=true"
import script from "./RulesContent.vue?vue&type=script&lang=js"
export * from "./RulesContent.vue?vue&type=script&lang=js"

import "./RulesContent.vue?vue&type=style&index=0&id=e1541f26&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1541f26"]])

export default __exports__